import { IsoDateTime, IsoDateTimeTz, IsoTime, IsoTimeTz } from '../../../types/iso-date';
import { deconstructDate } from '../../helper/deconstruct-date.function';
import { constructDate } from '../../helper/construct-date.function';

/**
 * Returns the end of the minute for the given ISO input.
 * - Date-time without tz -> 'YYYY-MM-DDTHH:mm:59.999'
 * - Date-time with tz -> 'YYYY-MM-DDTHH:mm:59.999Z|±HH:MM'
 * Throws for date-only inputs and invalid formats.
 */
export function endOfMinute<T extends IsoDateTime | IsoDateTimeTz | IsoTime | IsoTimeTz>(input: T): T {
  const deconstructed = deconstructDate(input);
  if (deconstructed._type !== 'dateTime'
    && deconstructed._type !== 'dateTimeTz'
    && deconstructed._type !== 'time'
    && deconstructed._type !== 'timeTz') {
    throw new Error('endOfMinute: invalid ISO date/time string');
  }
  deconstructed.seconds = 59;
  deconstructed.milliseconds = 999;
  return constructDate(deconstructed) as unknown as T;
}

